import React, { useEffect, useState } from 'react'
import FloatingActionButton from '../../components/shared/FloatingActionButton'
import { Plus } from 'lucide-react'
import { motion } from 'framer-motion';
import SettingsTable from './SettingsTable';
import useDidFetch from '../../custom_hooks/useDidfetch';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
import toast from 'react-hot-toast';
import SettingsModal from './SettingsModal';

export default function Settings() {
    const [settingsList, setSettingsList] = useState([]);
    const [editData, setEditData] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    const runOnce = useDidFetch();
    useEffect(()=>{
        runOnce(()=>{
            getAllSettings();
        });
    },[]);

    const getAllSettings = async () => {
        try {
            let response = await api.get(ENDPOINTS.getAllSettingsApi);
            let result = response?.data;
            if(response?.status == 200 || response?.status == 201){
                setSettingsList(result?.settings ?? [])
            }
        } catch (error) {
            console.log("Settings Error", error);
        }
    }

    const handleSubmitSettings =async (data, {isEdit}) => { 
        try {
            setBtnLoading(true)
            let response = await api.post(ENDPOINTS.createSettingsApi, data);
            let result = response?.data;
            if(response?.status == 200 || response?.status == 201){
                toast.success("Settings has been saved");
                setModalOpen(false);
                getAllSettings();
                setEditData({})
            }
        } catch (error) {
            console.log("Settings Error", error);
        }finally{
            setBtnLoading(false)}
    }
    const onClose = () =>{
        setModalOpen(false)
    }
    const handleEdit = (settingsData) =>{
        setEditData(settingsData);
        setModalOpen(true)
    }
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
        >
            <h1 className="text-3xl font-bold font-display text-gray-800">Settings Configuration</h1>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
                <SettingsTable onEdit={handleEdit} settingsList={settingsList} />
            </div>

            <SettingsModal editData={editData} isOpen={modalOpen} onClose={onClose} onSave={handleSubmitSettings} isLoading={btnLoading}/>
            <FloatingActionButton onClick={()=>{setModalOpen(true); setEditData({})}}>
                <Plus size={24} />
            </FloatingActionButton>
        </motion.div>
    )
}
